import { Layout } from 'antd';
import type { ReactElement, ReactNode } from 'react';

export function Right(props: { children: ReactNode }): ReactElement {
  return (
    <Layout.Content>{props.children}</Layout.Content>
  );
}
